import { React } from 'react';
import { motion } from 'framer-motion';
import '../../styles/components/hero-items/media-main.scss'

const MediaMain = () => (
    <div className="media-main">
        <img src="./img/home/NISAClassicV1_logo_small.png" alt="vol-2-logo" className="vol-logo media"/>
            <div className="nav-buttons">
            <div className="link-wrapper">
                    <a href="#trailer-container">
                        <motion.img src="./img/ui/trailers.png" alt="trailers" whileHover={{scale: 1.1}} className="shadow"/>
                    </a>
                    <a href="#wallpaper-container">
                        <motion.img src="./img/ui/wallpapers.png" alt="Wallpapers" whileHover={{scale: 1.1}}/>
                    </a>
                </div>
            </div>
    </div>
)

export default MediaMain;